/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-eye-slashed': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M9.766 22.579c-2.383-1.692-4.269-3.893-5.335-5.283a2.187 2.187 0 010-2.683c1.929-2.517 6.556-7.7 11.957-7.7 2.423 0 4.69 1.041 6.627 2.42M19.14 13.225a3.874 3.874 0 10-5.481 5.479M6.055 26.287L26.72 5.62M13.805 24.613c.838.25 1.708.378 2.583.383 5.402 0 10.028-5.184 11.957-7.701a2.188 2.188 0 00-.001-2.685 29.624 29.624 0 00-2.178-2.531" _stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
